import { jsx as _jsx } from "react/jsx-runtime";
import { AemConfigurationContext } from '@as-react/common-components';
import { EventEnum } from '@as-react/common-types';
import { EventUtil } from '@as-react/common-utils';
import * as React from 'react';
import { createRef, PureComponent } from 'react';
export var FlipClockFace;
(function (FlipClockFace) {
    FlipClockFace["MINUTE_COUNTER"] = "MinuteCounter";
    FlipClockFace["DAILY_COUNTER"] = "DailyCounter";
    FlipClockFace["TWELVE_HOUR_CLOCK"] = "TwelveHourClock";
    FlipClockFace["TWENTY_FOUR_HOUR_CLOCK"] = "TwentyFourHourClock";
    FlipClockFace["COUNTER"] = "Counter";
})(FlipClockFace || (FlipClockFace = {}));
export var FlipClockTheme;
(function (FlipClockTheme) {
    FlipClockTheme["LIGHT"] = "light";
    FlipClockTheme["DARK"] = "dark";
})(FlipClockTheme || (FlipClockTheme = {}));
export var FlipClockSize;
(function (FlipClockSize) {
    FlipClockSize["SMALL"] = "small";
    FlipClockSize["MEDIUM"] = "medium";
    FlipClockSize["LARGE"] = "large";
})(FlipClockSize || (FlipClockSize = {}));
const initialState = {
    CountDownTime: 0,
};
class FlipClock extends PureComponent {
    constructor(props) {
        super(props);
        this.element$ = null;
        this.onEvent = (e) => {
            if (e && e.detail === 'flipclock') {
                this.startFlipClock();
            }
        };
        this.startFlipClock = () => {
            if (this.props.countdown) {
                this.setCountdown();
            }
            else {
                this.setCounter();
            }
        };
        this.state = initialState;
        this.flipClockRef = createRef();
    }
    componentDidMount() {
        if (dynamicImports && dynamicImports.indexOf('flipclock') >= 0) {
            this.startFlipClock();
        }
        else {
            EventUtil.listen(EventEnum.DYNAMIC_IMPORT_SUCCESS, this.onEvent);
        }
    }
    setCountdown() {
        this.initializeClock(0);
        setInterval(() => {
            const currentDate = new Date();
            const futureDate = new Date(Number(this.props.dateTime));
            let countDownTime = futureDate.getTime() / 1000 - currentDate.getTime() / 1000;
            if (countDownTime <= 1) {
                countDownTime = 0;
            }
            this.element$.setTime(countDownTime);
            this.element$.start();
        }, 1000);
    }
    setCounter() {
        this.initializeClock();
    }
    initializeClock(time) {
        const flipClockRef = this.flipClockRef.current;
        this.element$ = $(flipClockRef).FlipClock(time, Object.assign({}, this.props));
    }
    setClassNames() {
        const { theme, size } = this.props;
        return `flip-clock-wrapper--${theme} flip-clock-wrapper--${size}`;
    }
    render() {
        return _jsx("div", { ref: this.flipClockRef, className: this.setClassNames() });
    }
}
const FlipClockWithContext = React.forwardRef((props) => (_jsx(AemConfigurationContext.Consumer, { children: (configuration) => {
        return _jsx(FlipClock, Object.assign({}, props, { language: configuration.lang }));
    } })));
FlipClockWithContext.displayName = 'FlipClockWithContext';
export default FlipClockWithContext;
